
document.addEventListener("DOMContentLoaded", function() {
  // Tabs
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      tabButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      tabContents.forEach(tc => tc.classList.remove("active"));
      const target = document.getElementById(btn.dataset.tab);
      if (target) {
        target.classList.add("active");
        
        // Smooth scroll zum Beginn des gewählten Tabs
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // "Nur Unterschiede" (CPU-Lines)
  const diffCheckbox = document.getElementById("toggle-differences");
  if (diffCheckbox) {
    diffCheckbox.addEventListener("change", () => {
      const cpuItems = document.querySelectorAll(".cpu-card");
      let cpuArrays = [];

      cpuItems.forEach((item) => {
        let lines = item.querySelectorAll(".spec-row");
        let lineTexts = [];
        lines.forEach(line => {
          lineTexts.push(line.getAttribute("data-line"));
        });
        cpuArrays.push(lineTexts);
      });

      let maxLines = Math.max(...cpuArrays.map(arr => arr.length));

      for (let i = 0; i < maxLines; i++) {
        let lineValues = [];
        cpuArrays.forEach((arr) => {
          lineValues.push(arr[i] ? arr[i] : null);
        });
        let allSame = true;
        let firstVal = lineValues[0];
        if (firstVal === null) {
          allSame = false;
        } else {
          for (let c = 1; c < lineValues.length; c++) {
            if (lineValues[c] === null || lineValues[c] !== firstVal) {
              allSame = false;
              break;
            }
          }
        }
        cpuItems.forEach((item) => {
          let lines = item.querySelectorAll(".spec-row");
          let row = lines[i];
          if (row) {
            if (diffCheckbox.checked && allSame) {
              row.style.display = "none";
            } else {
              row.style.display = "block";
            }
          }
        });
      }
    });
  }

  // Collapsible "Technische Daten"
  const toggleTechBtn = document.querySelector(".toggle-tech-btn");
  const techCollapsible = document.querySelector(".tech-details-collapsible");
  if (toggleTechBtn && techCollapsible) {
    toggleTechBtn.addEventListener("click", function() {
      techCollapsible.classList.toggle("expanded");
      if (techCollapsible.classList.contains("expanded")) {
        toggleTechBtn.textContent = "Technische Daten ausblenden";
      } else {
        toggleTechBtn.textContent = "Technische Daten anzeigen";
      }
    });
  }

  // Performance-Bar Script
  const maxScore = 10000; // anpassen an deine Skala
  const bars = document.querySelectorAll(".performance-bar-wrapper");
  bars.forEach(wrapper => {
    let val = parseInt(wrapper.getAttribute("data-score"));
    if (!val || isNaN(val)) val = 0;
    if (val > maxScore) val = maxScore; // deckeln
    let percent = (val / maxScore) * 100;
    
    // Fülle die .performance-bar per width
    const barDiv = wrapper.querySelector(".performance-bar");
    barDiv.style.width = percent + "%";
  });

  // ========== FAQ-DROPDOWN SCRIPT ==========
  const faqItems = document.querySelectorAll(".faq-item");
  
  if (faqItems.length > 0) {
    faqItems.forEach(item => {
      item.addEventListener("click", () => {
        item.classList.toggle("active");
      });
    });
  }
});
